import * as React from 'react';

import { SearchBox } from '../SearchBox';
import { ISearchInputProps } from './SearchInput.types';

export class SearchInput extends React.Component<ISearchInputProps> {
  render() {
    return (
      <div data-hook="search-form">
        <SearchBox
          clearLabel={this.props.clearLabel}
          onChange={this.props.onChange}
          onClear={this.props.onClear}
          onSubmit={this.props.onSubmit}
          placeholder={this.props.placeholder}
          value={this.props.value}
        />
      </div>
    );
  }
}
